module.exports = __webpack_public_path__ + "img/mastercard.d3d386d5.png";